import React, { useState } from "react";
import StarRatings from "react-star-ratings";
import { Ratings } from "../../../helper";

const Rating = ({ icon, colour, initialRating, isViewOrEdit, PupilProgressReport, subjectIndex, isAdditionalSubject }) => {
  console.log({savedReport:icon, colour, initialRating});
  const ratingIcon = icon ? icon : null;
  const ratingColor = colour ? colour : null;
  const [rating, setRating] = useState(initialRating ? initialRating : 0);
  const changeRatingFunc = (newRating) => {
    if(isAdditionalSubject){
      PupilProgressReport.additionalSubject[subjectIndex].rating.value=newRating
    } else {
      PupilProgressReport.subjects[subjectIndex].rating.value=newRating
    }
    setRating(newRating);
  }
  return (
    <div style={{ pointerEvents: !isViewOrEdit ? "none" : "" }}>
      <StarRatings rating={rating} svgIconPath={ratingIcon ? ratingIcon : Ratings.Icons.Star} starEmptyColor="#D9D9D9" starHoverColor={ratingColor ? ratingColor : Ratings.Colours.Yellow} starRatedColor={ratingColor ? ratingColor : Ratings.Colours.Yellow} changeRating={changeRatingFunc} />
    </div>
  )
}

export { Rating }